/* eslint-disable react/display-name */
import React, { useState } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row, Space } from 'antd'
import { TableListPage } from 'Components/common/Table'
import { CreditNotesData, GrnData, GrnItemInfo } from 'Store/grn/types'
import { formatDateTime, numberWithComma } from 'helpers/format'
import CnDetail from './CnDetail'

type Props = {
  grnData?: GrnData
  creditNotes: CreditNotesData[]
  onClickEdit?: (products: GrnItemInfo) => void
}

const CnListTable: React.FunctionComponent<Props> = props => {
  const { creditNotes, grnData } = props
  const [showDrawer, setShowDrawer] = useState(false)
  const [activeData, setActiveData] = useState(undefined as undefined | CreditNotesData)

  const DetailDrawer = (
    <CnDetail
      visible={showDrawer}
      onCloseDrawer={() => setShowDrawer(false)}
      creditNotesData={activeData}
      detail={grnData}
    />
  )

  const countTotal = () => {
    let total = 0
    creditNotes &&
      creditNotes.forEach(item => {
        total += item.total_price || 0
      })
    return total
  }

  const onViewDetail = (data: CreditNotesData) => {
    setActiveData(data)
    setShowDrawer(true)
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      width: '50px',
      render: (value: any, record: any, index: number) => {
        return index + 1
      },
    },
    {
      title: 'เลขที่ใบลดหนี้',
      dataIndex: 'credit_note_no',
      key: 'credit_note_no',
      width: '200px',
      render: (val: string, record: CreditNotesData) => {
        return <CnNo onClick={() => onViewDetail(record)}>{val}</CnNo>
      },
    },
    {
      title: 'จำนวนรายการ',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (value: number) => numberWithComma(value || 0),
    },
    {
      title: 'ยอดลดหนี้',
      dataIndex: 'total_price',
      key: 'total_price',
      render: (value: number) => numberWithComma(value || 0, true),
    },
    {
      title: 'วันที่ลดหนี้',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val: string) => formatDateTime(val),
    },
  ]

  const renderHeader = () => {
    return (
      <Row justify="space-between" gutter={[32, 32]} align="middle">
        <Col>
          <BoxTitle>รายการลดหนี้</BoxTitle>
        </Col>
      </Row>
    )
  }

  return (
    <BoxWrapper>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          {renderHeader()}
          <TableListPage
            rowKey="option_id"
            tableName="reduce-dept"
            columns={columns}
            datas={creditNotes}
            size={'small'}
            scrollX={400}
          />
        </Col>
      </Row>
      <Row justify="space-between" gutter={[8, 8]}>
        <Col></Col>
        <Col>
          <SummaryPrice>
            <Space>
              ยอดลดหนี้ทั้งหมด
              <Price> {numberWithComma(countTotal(), true)} </Price> บาท
            </Space>
          </SummaryPrice>
        </Col>
      </Row>
      {DetailDrawer}
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const SummaryPrice = styled.div`
  text-align: right;
`

const Price = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title2};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const CnNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
`

export default CnListTable
